import FileType from 'file-type/browser';

export default class FileUploadHelper {
  static async getFileType (file) {
    return await FileType.fromBlob(file);
  }

  static async getIsValidFileType (file, acceptedTypes) {
    if (!acceptedTypes) {
      return true;
    }

    const type = await FileUploadHelper.getFileType(file);

    if (!type) {
      return false;
    }

    return acceptedTypes.includes(type.mime);
  }
}
